export default "__VITE_ASSET__BgVbENLV__"